import axios from './request'
import config from '@/config'

const { baseURL } = config;

//获取IOS下载是企业版还是appstore版
export const getIosGuideType = function() {
  let url = baseURL + 'h5/system/v1.0.2.6/getIosGuideType'
  return axios.post(url, {}, { headers: {'appType': '4'} })
}

export const createAssist = function(userId) {
  let url = baseURL + '/h5/schoolFissionActivity/v1.0.5.1/create';
  return axios.post(url, {}, {headers: {userId}});
}

export const getAssistDetail = function({userId}) {
  let url = baseURL + 'h5/schoolFissionActivity/v1.0.5.1/detail';
  return axios.post(url, {}, {headers: {userId}});
}

export const getAssistUser = function(params) {
  let url = baseURL + 'h5/schoolFissionActivity/v1.0.5.1/assistUsers';
  return axios.post(url, params.data, {headers: params.headers});
}

export const pickUpPrize = function(params) {
  let url = baseURL + 'h5/schoolFissionActivity/v1.0.5.1/takePrize';
  return axios.post(url, params.data, {headers: params.headers});
}

export const getJoinUserInfo = function(params) {
  let url = baseURL + 'h5/schoolFissionActivity/v1.0.5.1/getJoinUserInfo';
  return axios.post(url, params.data, {headers: params.headers});
}

export const doAssist = function(params) {
  let url = baseURL + 'h5/schoolFissionActivity/v1.0.5.1/doAssist';
  return axios.post(url, params.data, {headers: params.headers});
}
export const queryCopyWriting = function(params) {
  let url = baseURL + 'game/copywriting/v1.0.2.5/queryCopyWriting';
  return axios.post(url, params.data, {headers: params.headers});
}
// 分享查询接口
export const queryShareInfo=function(param) {
  // let url = baseURL + '/user/shareInfo/queryShareInfo'
  let url = baseURL + 'h5/shareInfo/queryShareInfo'
  return axios.post(url, param)
}


// WEBPACK FOOTER //
// ./src/api/assistApi.js